import { Injectable } from '@angular/core';
import { UserDataService } from '../services/user-data.service';
import { ReportSaveService } from './report-save.service';
import { MongoService } from '../services/mongo.service';
import { StateService } from '../services/state.service';

@Injectable({
  providedIn: 'root'
})
export class RegisteredUsersWithoutStatusAcceptationReportService {

  constructor(
    public userDataService: UserDataService,
    private savingService: ReportSaveService,
    private mongoService: MongoService,
    private stateService: StateService,
  ) { }

  public async generateReport() : Promise<void> {
    try {
      const allUsersData = await this.userDataService.getAllExistingUsersData();
      const registeredUsersData = await this.getRegisteredUsersWithoutStatusAcceptation(allUsersData);
      const allUsersContactsData = await this.mongoService.getAllUsersContactsData();

      const state = this.stateService.getState();
      const isPumpState = state === "state-pumps";
      const isACState = state === "state-airconditioners";
      const preparedData = this.mergeByUserEmail(registeredUsersData, allUsersContactsData, { isPumpState, isACState });

      const reportData = this.generateReportContent(preparedData);
      this.save(reportData);
    } catch(e) {
      console.warn(e);
    }
  }

  private async getRegisteredUsersWithoutStatusAcceptation(usersData: Array<any>): Promise<Array<any>> {
    const registeredUsersWithoutStatusAcceptation: Array<any> = [];
    const state = this.stateService.getState();
    const isPumpState = state === 'state-pumps';
    const isACState = state === 'state-airconditioners';
  
    usersData.forEach(user => {
      if (user.registered && (!user.isPumpStatutAccepted || !user.isAirConditionStatutAccepted) ) {
        const hasPumpProducts = isPumpState && user.pumpRegisteredProducts?.length > 0;
        const hasACProducts = isACState && user.airConditionRegisteredProducts?.length > 0;
        if (hasPumpProducts || hasACProducts) {
          registeredUsersWithoutStatusAcceptation.push(user);
        }
      }
    });
    return registeredUsersWithoutStatusAcceptation;
  }

  private generateReportContent(rankingArray: Array<any>) : Array<Array<any>> {
    const result: Array<Array<any>> = [];
    result.push(this.generateReportHeader());
    result.push(['']);
    let iterator = 1;
    rankingArray.forEach(u => {
      result.push([
        u.userEmail,
        u.registeredProductsCount,
        u.companyName, 
        u.firstName, 
        u.lastName, 
        u.phoneNumber, 
        u.voivodeship,
        u.streetName,
        u.buildingNumber,
        u.city,
        u.postalCode
      ]);
      iterator++;
    });
    iterator = 1;


    // sortowanie po województwie (indeks 5)
    const header = result[0];
    const emptyRow = result[1];
    const dataRows = result.slice(2);

    dataRows.sort((a, b) => {
      const aVal = (a[5] || '').toString().toLowerCase();
      const bVal = (b[5] || '').toString().toLowerCase();
      return aVal.localeCompare(bVal, 'pl');
    });

    return [header, emptyRow, ...dataRows];


    // return result;
  }

  private generateReportHeader() : Array<string> {
    return [
      'Adres email',
      'Liczba urządzeń',
      'Nazwa firmy', 
      'Imię', 
      'Nazwisko', 
      'Nr telefonu', 
      'Województwo',
      'Ulica',
      'Numer',
      'Miejscowość',
      'Kod'
    ];
  }

  private save(data: Array<Array<any>>) : void {
    this.savingService.saveXlsxReport(data, 'zarejestrowani_bez_akceptacji_regulaminu.xlsx', 'Raport')
  }

  /**
   * Łączy dane z dwóch tablic po userEmail.
   * Jeśli w baseArr pole jest niepuste, ma priorytet nad wartością z detailsArr.
   * @param {Array<Object>} baseArr  - pierwsza tablica (ta z polami punktów/pozycji)
   * @param {Array<Object>} detailsArr - druga tablica (ta z danymi adresowymi)
   * @returns {Array<Object>} nowa tablica obiektów z polami: userEmail + dane z obu tablic
   */
  mergeByUserEmail(baseArr: any, detailsArr: any, { isPumpState = false, isACState = false } = {}) {
    const wantedFields = [
      'firstName',
      'lastName',
      'companyName',
      'nipCode',
      'phoneNumber',
      'streetName',
      'buildingNumber',
      'city',
      'postalCode',
      'voivodeship'
    ];

    // Mapowanie: email(lowercase) -> obiekt szczegółów
    const detailsMap = new Map(
      (detailsArr || []).map((d: any) => [(d.userEmail || '').toLowerCase(), d])
    );

    return (baseArr || []).map((b: any) => {
      const key = (b.userEmail || '').toLowerCase();
      const d: any = detailsMap.get(key);

      const merged: any = { userEmail: b.userEmail || '' };

      for (const f of wantedFields) {
        const baseVal = b[f];
        const detailVal = d?.[f];

        // priorytet: baseArr → detailsArr → pusty string
        merged[f] = baseVal && baseVal.toString().trim() !== ''
          ? baseVal
          : (detailVal && detailVal.toString().trim() !== '' ? detailVal : '');
      }

           // Liczba zarejestrowanych produktów z pierwszej tablicy – wg przekazanych flag
           merged.registeredProductsCount = isPumpState
           ? (b.pumpRegisteredProducts?.length ?? 0)
           : (isACState
               ? (b.airConditionRegisteredProducts?.length ?? 0)
               : 0);

      return merged;
    });
  }
}
